// extracted by mini-css-extract-plugin
export var divider = "_jp-0";
export var systemMessage = "_jp-1";